import React from 'react';
import SectionTitle from '../components/ui/SectionTitle';

const Datenschutz: React.FC = () => {
  return (
    <div className="pt-32 pb-20">
      <div className="container-custom">
        <SectionTitle title="Datenschutzerklärung" />
        
        <div className="prose max-w-none">
          <h2 className="text-2xl font-semibold mb-4">1. Verantwortlicher im Sinne der DSGVO</h2>
          <p className="mb-4">
            Für die Verarbeitung personenbezogener Daten im Rahmen dieser Website ist verantwortlich:
          </p>
          <p className="mb-6">
            Monica Meier<br />
            Starnberger Str. 24, 82131 Gauting<br />
            Festnetz: +49 89 90157634<br />
            Mobil: +49 171 1144557<br />
            E-Mail: m.meier@vorsorgewerk24.de
          </p>
          
          <p className="mb-4">
            Ich bin als selbstständige Handelsvertreterin gemäß § 84 HGB tätig und arbeite in Kooperation mit folgenden Partnerunternehmen:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>A&K Vorsorgespezialisten UG, Sonnenhang 10A, 51381 Leverkusen (Versicherungsvermittlung)</li>
            <li>4Motion GmbH, Rosa-Luxemburg-Str. 19/21, 04103 Leipzig (Energievermittlung: Strom & Gas)</li>
          </ul>
          <p className="mb-6">
            Die jeweilige Vermittlung erfolgt ausschließlich im Namen und auf Rechnung der genannten Partnerunternehmen.
          </p>

          <h2 className="text-2xl font-semibold mb-4">2. Zwecke der Datenverarbeitung & Rechtsgrundlagen</h2>
          <h3 className="text-xl font-semibold mb-3">Betrieb dieser Website</h3>
          <p className="mb-2">Zweck: Technische Bereitstellung, Sicherheit, Optimierung</p>
          <p className="mb-4">Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</p>

          <h3 className="text-xl font-semibold mb-3">Kontaktaufnahme über das Formular oder per E-Mail</h3>
          <p className="mb-2">Zweck: Vertragsanbahnung und Weiterleitung an die jeweiligen Kooperationspartner</p>
          <p className="mb-4">Rechtsgrundlage:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
            <li>Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)</li>
          </ul>

          <h3 className="text-xl font-semibold mb-3">Verarbeitung durch Kooperationspartner im Rahmen des Mandats</h3>
          <p className="mb-2">Zweck: Beratung, Vermittlung und Betreuung von Versicherungs- bzw. Energieverträgen</p>
          <p className="mb-4">Verantwortlich:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>A&K Vorsorgespezialisten UG bzw.</li>
            <li>4Motion GmbH</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">3. Kategorien verarbeiteter Daten</h2>
          <ul className="list-disc pl-6 mb-6">
            <li>Name, E-Mail-Adresse, Telefonnummer</li>
            <li>Inhalte aus Anfragen und Formularen</li>
            <li>Angaben zum Versicherungs- oder Energiebedarf</li>
            <li>technische Daten (z. B. IP-Adresse, Datum/Uhrzeit, Browser)</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">4. Speicherdauer</h2>
          <p className="mb-4">Leaddaten auf dieser Website: max. 6 Monate nach letzter Aktivität oder Widerruf der Einwilligung</p>
          <p className="mb-2">Vertragsbezogene Daten bei den Kooperationspartnern:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Während der Mandatsdauer</li>
            <li>6 Jahre (z. B. Korrespondenz)</li>
            <li>10 Jahre (z. B. Abrechnungen, steuerlich relevante Unterlagen)</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">5. Betroffenenrechte</h2>
          <p className="mb-4">Sie haben jederzeit das Recht auf:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Auskunft (Art. 15 DSGVO)</li>
            <li>Berichtigung (Art. 16 DSGVO)</li>
            <li>Löschung (Art. 17 DSGVO), sofern keine gesetzlichen Pflichten entgegenstehen</li>
            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruch gegen Verarbeitung (Art. 21 DSGVO)</li>
            <li>Widerruf Ihrer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
          </ul>

          <p className="mb-2">Ansprechpartner für Website-bezogene Datenverarbeitung:</p>
          <p className="mb-4">Monica Meier, E-Mail: m.meier@vorsorgewerk24.de</p>

          <p className="mb-2">Ansprechpartner für die Verarbeitung im Rahmen eines Mandats:</p>
          <p className="mb-6">Der jeweilige Kooperationspartner (A&K Vorsorgespezialisten UG bzw. 4Motion GmbH)</p>

          <h2 className="text-2xl font-semibold mb-4">6. Beschwerderecht bei der Aufsichtsbehörde</h2>
          <p className="mb-6">
            Sie haben das Recht, sich bei der für Sie zuständigen Landesdatenschutzaufsichtsbehörde zu beschweren, 
            wenn Sie der Ansicht sind, dass Ihre personenbezogenen Daten unrechtmäßig verarbeitet werden.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;